import { Controller } from "@hotwired/stimulus"

// Select-only combobox: a button that opens a menu of options and writes the
// chosen value into a hidden input (not a Flowbite component).
//
//   <div data-controller="combobox">
//     <input type="hidden" data-combobox-target="input">
//     <button data-combobox-target="button" data-action="combobox#toggle"
//             role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="opts">
//       <span data-combobox-target="placeholder">Choose…</span>
//     </button>
//     <div data-combobox-target="menu" class="hidden">
//       <ul id="opts" role="listbox">
//         <li role="presentation">
//           <button role="option" data-action="combobox#select" data-value="x" data-name="X">X</button>
//         </li>
//       </ul>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["button", "menu", "input", "placeholder"]

  connect() {
    // Remember the prompt so choosing the empty option can restore it after
    // a real value has replaced it.
    this.placeholder = this.placeholderTarget.textContent.trim()
  }

  toggle() {
    this._setOpen(this.menuTarget.classList.contains("hidden"))
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    const name =
      event.currentTarget.dataset.name ||
      event.currentTarget?.textContent.trim()

    this.inputTarget.value = value
    this.placeholderTarget.textContent = value
      ? name || value
      : this.placeholder
    this.menuTarget
      .querySelectorAll('[role="option"]')
      .forEach((option) =>
        option.setAttribute("aria-selected", option === event.currentTarget),
      )

    this._setOpen(false)
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  // Keeps the button's aria-expanded in step with the menu, per the ARIA
  // select-only combobox pattern.
  _setOpen(open) {
    this.menuTarget.classList.toggle("hidden", !open)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", open)
    }
  }
}
